module.exports = __webpack_public_path__ + "static/media/pic2.d768b569.jpg";